module.exports = __webpack_public_path__ + "img/story1_1.3c921b43.png";